import { render, staticRenderFns } from "./FormVerify.vue?vue&type=template&id=6f7bec55&scoped=true"
import script from "./FormVerify.vue?vue&type=script&lang=js"
export * from "./FormVerify.vue?vue&type=script&lang=js"
import style0 from "./FormVerify.vue?vue&type=style&index=0&id=6f7bec55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7bec55",
  null
  
)

export default component.exports